var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFnr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "FNR",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-148.3 560.8 1886.9 174.5",
    style: {
      enableBackground: "new -148.3 560.8 1886.9 174.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#393839;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-147.6,732.4V565H-46v30.1h-69v36.6h56.5v30.1H-115v70.5H-147.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-12.1,732.4V565h32.6v167.4H-12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.9,732.4L94,625.5h-0.2c0,0,0.2,7.4,0.2,12.9v94H63.6V565h34.2L148.9,672h0.2c0,0-0.2-7.4-0.2-12.9v-94 h30.4v167.4H144.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222.3,732.4V565h52.9c26.3,0,45.1,11.6,53.6,32.8c2.7,6.9,4.2,15.2,4.2,25.7V674c0,10.5-1.6,18.8-4.2,25.7 c-8.5,21.2-27.2,32.8-53.6,32.8H222.3z M300.7,624.2c0-6.3-0.7-11.8-2.5-15.6c-4-8.5-10.7-12.1-22.1-12.1h-21.4v104.7h21.4 c11.4,0,18.1-3.6,22.1-12.1c1.8-3.8,2.5-9.4,2.5-15.6V624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M514.1,732.4l-50.9-106.9H463c0,0,0.2,7.4,0.2,12.9v94h-30.4V565H467L518.1,672h0.2c0,0-0.2-7.4-0.2-12.9v-94 h30.4v167.4H514.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M591.6,732.4V565h101.1v30.1h-68.5v36.4h56.5v30.1h-56.5v40.6h68.5v30.1H591.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M838.5,732.4l-24.8-113.8l-24.8,113.8h-38.2L716.6,565h34.6l19,116.5h1.3L797.2,565h33l25.7,116.5h1.3 l19-116.5h34.6l-34.2,167.4H838.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1084,732.4c-4.2-4.5-6-12.7-6.7-20.1l-2.2-26.3c-1.3-15.8-8.9-21.9-25.9-21.9h-15v68.3h-32.4V565h51.6 c7.6,0,14.3,0.7,19.6,1.8c21.9,4.9,35.9,19.2,35.9,42.6c0,17-8.9,30.8-25.4,38.4v0.2c14.5,5.1,22.1,14.5,23.4,31.7l2.5,29.9 c0.7,8.5,3.1,16.7,9.4,21.4v1.3H1084z M1052.3,634.5c15.4,0,23.9-8.7,23.9-21c0-9.2-5.1-14.3-13.4-16.3c-2.9-0.7-6.9-1.1-11.4-1.1 h-17.2v38.4H1052.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1203.2,734.7c-21.4,0-42.4-11.4-51.1-32.8c-2.7-6.9-4-15.2-4-25.7v-54.9c0-10.5,1.3-18.8,4-25.7 c8.7-21.4,29.7-32.8,51.1-32.8h2.5c21.4,0,42.2,11.6,50.9,32.8c2.9,6.9,4.2,15.2,4.2,25.7v54.9c0,10.5-1.3,18.8-4.2,25.7 c-8.7,21.2-29.5,32.8-50.9,32.8H1203.2z M1205.7,703.7c7.8,0,16.1-3.3,20.1-11.8c1.8-3.8,2.5-9.4,2.5-16.1v-54 c0-6.7-0.7-12.3-2.5-16.1c-4-8.5-12.3-11.8-20.1-11.8h-2.5c-8,0-16.1,3.3-20.1,11.8c-2,3.8-2.5,9.4-2.5,16.1v54 c0,6.7,0.4,12.3,2.5,16.1c4,8.5,12.1,11.8,20.1,11.8H1205.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1386.1,732.4l-11.2-43.1h-43.3l-11.2,43.1h-33.3l46.9-167.4h38.4l46.9,167.4H1386.1z M1353.5,606.1h-0.9 l-12.9,52.9h27.2L1353.5,606.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1448.1,732.4V565h52.9c26.3,0,45.1,11.6,53.6,32.8c2.7,6.9,4.2,15.2,4.2,25.7V674c0,10.5-1.6,18.8-4.2,25.7 c-8.5,21.2-27.2,32.8-53.6,32.8H1448.1z M1526.5,624.2c0-6.3-0.7-11.8-2.5-15.6c-4-8.5-10.7-12.1-22.1-12.1h-21.4v104.7h21.4 c11.4,0,18.1-3.6,22.1-12.1c1.8-3.8,2.5-9.4,2.5-15.6V624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1672.5,615.5c0-13.4-7.8-22.8-23.2-22.8c-13.4,0-20.1,6.9-20.1,16.1c0,10,6.7,15.6,17.4,19.4l14.3,4.9 c26.1,8.9,45.5,23.9,45.5,52c0,29.7-23.7,49.6-55.8,49.6c-36.8,0-57.6-22.5-58.5-54.2h32.1c0.7,14.5,11.4,24.6,25.7,24.6 c13.6,0,23.9-6.9,23.9-19.4c0-11.2-10.3-17.6-21.9-21.9l-14.1-5.1c-23-8.5-41.3-19-41.3-49.6c0-29.2,24.1-46.2,54-46.2 c31.3,0,55.4,15.8,53.8,52.7H1672.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1713.3,583.9v-13.2h-4.1v-3h11.4v3h-4.1v13.2H1713.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1734.4,583.9v-9.1c0-0.5,0-1.3,0-1.3h0l-3,7.4h-1.8l-3-7.4h0c0,0,0,0.7,0,1.3v9.1h-2.9v-16.3h3.4l3.4,8.7 l3.4-8.7h3.4v16.3H1734.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFnr);
export default __webpack_public_path__ + "static/media/fnr.585ffd9bcfbc3ec3f16966312cfa8e35.svg";
export { ForwardRef as ReactComponent };